import { NodeViewWrapper } from "@tiptap/react";
import React from "react";
import "./excel-node-view.scss";

type Props = {
  node: any;
};

export function ExcelNodeView({ node }: Props) {
  const { columns, rows } = JSON.parse(node.attrs.data);

  const pageSize = 5;
  const [page, setPage] = React.useState(1);

  const total = rows.length;

  const totalPages = Math.ceil(total / pageSize);
  const startIndex = (page - 1) * pageSize;
  const paginatedRows = rows.slice(startIndex, startIndex + pageSize);

  return (
    <NodeViewWrapper className="excel-node-view">
      <div className="table-responsive">
        <table className="table excel-table">
          <thead>
            <tr>
              {columns.map((col: string) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {paginatedRows.map((row: any[], i: number) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <span>Resultados por página: {paginatedRows.length}</span>

        <div>
          <button disabled={page === 1} onClick={() => setPage((p) => p - 1)}>
            ‹
          </button>

          <span>
            {page} / {totalPages}
          </span>

          <button
            disabled={page === totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            ›
          </button>
        </div>
      </div>
    </NodeViewWrapper>
  );
}
